import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import { useState, useEffect } from "react";
import Colors from "../../../Resources/Color";

/**
 * NumberCard Component
 * A minimalistic card component for displaying numeric ranges
 */
export const NumberCard = ({
  number,
  isSelected = false,
  isHovered = false,
  shouldFadeOut = false,
  onPress,
  onMouseEnter,
  onMouseLeave,
  animationDelay = 0,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, animationDelay);

    return () => clearTimeout(timer);
  }, [animationDelay]);

  return (
    <div
      style={{
        flex: 1,
        minWidth: 90,
        maxWidth: 120,
        opacity: isVisible ? 1 : 0,
        transform: `translateY(${isVisible ? 0 : 10}px)`,
        transition: "opacity 400ms ease-out, transform 400ms ease-out",
      }}
    >
      <TouchableOpacity
        style={[
          styles.card,
          isHovered && styles.cardHovered,
          isSelected && styles.cardSelected,
          {
            opacity: shouldFadeOut ? 0 : 1,
            transition: "opacity 300ms ease-in-out",
            pointerEvents: shouldFadeOut ? "none" : "auto",
          },
        ]}
        onPress={onPress}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <Text
          style={[styles.numberText, isSelected && styles.numberTextSelected]}
        >
          {number}
        </Text>
      </TouchableOpacity>
    </div>
  );
};

const styles = StyleSheet.create({
  card: {
    flex: 1,
    minWidth: 90,
    maxWidth: 120,
    height: 60,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 14,
    borderWidth: 1,
    borderColor: Colors.borderColor,
    backgroundColor: Colors.whiteColor,
    transitionProperty: "background-color, border-color",
    transitionDuration: "200ms",
    transitionTimingFunction: "ease-in-out",
  },
  cardHovered: {
    borderColor: Colors.grayColor,
  },
  cardSelected: {
    backgroundColor: `${Colors.bubbleColor}10`,
    borderColor: Colors.bubbleColor,
  },
  numberText: {
    fontSize: 14,
    fontWeight: "500",
    color: Colors.blackColor,
  },
  numberTextSelected: {
    // Can add specific selected text style if needed
  },
});

export default NumberCard;
